// extracted by mini-css-extract-plugin
module.exports = {"Home":"styles_Home__3pfBF","fadeIn":"styles_fadeIn__276fH","Home-wrapper":"styles_Home-wrapper__a8wbg"};